import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { ReportsVM } from '../../Structure/ViewModels/Admin/ReportsVM';

const Reports = () => {
    const [vm , setVm] = useState<{viewModel:ReportsVM}>({viewModel:new ReportsVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getData()
    },[])

    const [from,setFrom] = useState('')
    const [to,setTo] = useState('')

    useEffect(() => {
      const handleScroll = () => {
          const elementCourses = scrollableRefCourses.current;
          if (elementCourses && elementCourses.scrollTop + elementCourses.clientHeight+10 >= elementCourses.scrollHeight) {
            control.addData()
          }
      };
  
      const elementCourses = scrollableRefCourses.current;
      if (elementCourses) {
          elementCourses.addEventListener('scroll', handleScroll);
      }
  
      return () => {
          if (elementCourses) {
              elementCourses.removeEventListener('scroll', handleScroll);
          }
      };
  });

  const scrollableRefCourses = useRef<HTMLDivElement | null>(null);

  useEffect(()=>{
    if(control.Refresh){
        control.getData()
    }
  },[control.Refresh])


  return (
    <Container>
        <Row>
            <div className='d-flex flex-wrap justify-content-around pt-5 pb-3'>
                <div  className='p-2 my-auto'>
                    <input type="date" className='input-field' value={from} onChange={a=>setFrom(a.target.value)} />
                </div>
                <div  className='p-2 my-auto'>
                    <input type="date" className='input-field'  value={to} onChange={a=>setTo(a.target.value)} />
                </div>
                <div  className='p-2 my-auto'>
                    <button className='button-II btn-cl-I px-5 py-2' onClick={()=>{ control.From = from ; control.To = to ; control.searchData() }}>بحث</button>
                </div>
            </div>
            {control.Show(
            <div ref={scrollableRefCourses} className='overflow-y-auto' style={{maxHeight:'500px'}}>
                <div className='p-3 overflow-x-auto'>
                        {
                            control.Data.map((item,index)=>(
                                <div  key={index} className='py-3' style={{direction:'rtl'}}>
                                    <h5 className='py-1'>({item.employee_key})&nbsp;&nbsp;{item.employee_name}</h5>
                                    <h6 className='py-1'>{item.device_name} , {new Date(item.created_at).toLocaleString()}</h6>
                                    <div className='py-1'>{item.log}</div>
                                </div>
                            ))
                        }
                </div>
            </div>)}
        </Row>
    </Container>
  )
}

export default Reports
